import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=2d603adc&scoped=true"
import script from "./PasswordForm.vue?vue&type=script&lang=js"
export * from "./PasswordForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordForm.vue?vue&type=style&index=0&id=2d603adc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d603adc",
  null
  
)

export default component.exports